import config from "../../config/config";
import { getToken } from "js/formatting/getToken";

export async function getAgentAssistant(AgentID = "") {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
  };
  let queryString = "";
  if (AgentID !== "") {
    queryString = "AgentID=" + AgentID;
  }
  const response = await fetch(
    config.REG_API_BASE_URL + "/User/agentassistant?" + queryString,
    options
  );

  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
